export default {
  __name: 'DefaultHeader',
  setup(__props) {

return { __sfc: true, }
}

}